import { useMemo } from "react";
import ReactImageMagnify from 'react-image-magnify';
import { FlagRegionByIso } from "components/Function";
import { Link } from "react-router-dom";

const useColumnTableInfluencersByShop = (heightRow = 100) => {
    const columns = useMemo(() => {
        return [
            {
                field: "_id",
                headerName: "",
                sortable: false,
                editable: false,
                cellClass: "centered-cell",
                width: 10,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            },
            {
                field: "influencer_id",
                headerName: "Influencer",
                sortable: false,
                editable: false,
                autoHeight: true,
                cellClass: "overflow-visible",
                width: 500,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                        <div className="me-3">
                            {/* <Link to={row.avatar_url} target="_blank"> */}
                                <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: row.avatar_url }, largeImage: { src: row.avatar_url, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 }, imageClassName: "symbol symbol-45px symbol-circle" }} />
                            {/* </Link> */}
                        </div>
                        <div
                            className="d-flex flex-column lh-lg gap-2 w-100px"
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                className="mb-0 fw-bold"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                <Link
                                    role="button"
                                    target="_blank"
                                    to={`/admin/spy-advanced/influencers/${row.influencer_id}`}
                                >
                                    {row.influencer_name}
                                </Link>
                                {row.certificate_type && <img src={require(`components/assets/media/misc/${ row.certificate_type === 2 ? "tick_blue" : "tick_yellow" }.png`)} alt="" width="20" height="20" className="ms-1" data-tooltip-id="my-tooltip" data-tooltip-content={ row.certificate_type === 2 ? "Enterprise Certification" : "Verified account" } />}
                            </span>
                            <div className="d-flex align-items-center gap-2 flex-wrap fs-7">
                                @{row.unique_id}
                                <button
                                    className="btn btn-link text-hover-primary p-0"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Copy"}
                                    onClick={() => navigator.clipboard.writeText(row.unique_id)}
                                >
                                    <i className="ki-duotone ki-copy">
                                    </i>
                                </button>
                            </div>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {row.region?.key ? (
                                    <FlagRegionByIso name={row.region.name} iso={row.region.key} />
                                ) : (
                                    ""
                                )}
                                {Boolean(row.is_email) && (
                                    <i
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Email"}
                                        className="fa fa-envelope-o fs-3"
                                    ></i>
                                )}
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                field: "follower_count",
                headerName: "Followers",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "follower_30d_count",
                headerName: "New followers(30d)",
                headerClass: "text-info",
                cellClass: "centered-cell",
                sortable: false,
                cellRenderer: ({ value: cell, data: row }) => <span className="text-danger">{row.follower_30d_count}</span>,
            },
            {
                field: "likes_per_followers",
                headerName: "Likes/Followers",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "video_count",
                headerName: "Videos",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "views_per_video",
                headerName: "ViewsPerVideo",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "engagement_rate",
                headerName: "ER Rate",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_product_cnt",
                headerName: "No. of Products",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "-",
                headerName: "Actions",
                editable: false,
                cellClass: "centered-cell",
                width: 140,
                // pinned: "right",
                cellRenderer: ({ data: row }) => (
                    <>
                        <Link
                            role="button"
                            to={`/admin/spy-advanced/influencers/${row.influencer_id}`}
                            className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                            data-tooltip-id="my-tooltip"
                            target="_blank"
                        >
                            <i className="fa fa-search fs-2"></i>
                        </Link>
                    </>
                ),
            },
        ];
    }, [heightRow]);

    return columns;
};

export default useColumnTableInfluencersByShop;
